export default {
	0: [
		{ width: '34px', isCheckbox: true, isCheckboxAll: true, isCheckboxTotal: true },
		{
			text: "Department",
			value: "department_name"
		},
		{
			text: "User",
			value: "name"
		},
		{
			text: "Month",
			value: "month_name"
		},
		{
			text: "Bonus",
			value: "bonus"
		},
		{
			text: "Charge",
			value: "charge"
		},

		{
			text: "Salary",
			value: "salary"
		},
		{
			text: "Total",
			value: "total"
		},
	],
	1: [
		{ width: '34px', isCheckbox: true, isCheckboxAll: true, isCheckboxTotal: true },
		{
			text: "ID",
			value: "user_id",
			sortable: true,
			footer: "unique"
		},
		{
			text: "Employee",
			value: "employee",
			valueFilter: 'filter_employee',
			model: { value: 'list' },
			func: true,
			sortable: true,
		},
		{
			text: "Salary",
			value: "salary",
			sortable: true,
			footer: "sum"
		},
		{
			text: "Bonus",
			value: "bonus",
			sortable: true,
			footer: "sum"
		},
		{
			text: "Charge",
			value: "charge",
			sortable: true,
			footer: "sum"
		},
		{
			text: "Total",
			value: "total",
			sortable: true,
			dollar: true,
			footer: "sum"
		},
		{
			buttons: [
				{
					perm: true,
					value: 'openLoads',
					text: 'View st-t',
					icon: { value: 'icon_view', w: 17, h: 14 },
				}
			]
		},

	],
	2: [
		{
			text: "Name",
			value: "name"
		},
		{
			text: "Total invoice",
			value: "invoice_total"
		},
		// {
		// 	text: "Disp st-ts",
		// 	value: "dispatcher_statement"
		// },
		{
			text: "Salary",
			value: "salary"
		},
		{
			text: "Bonus",
			value: "bonus"
		},
		{
			text: "Charge",
			value: "charge"
		},
		// {
		// 	text: "Description",
		// 	value: "description"
		// },

		{
			text: "Total",
			value: "total"
		},
	],
	3: [
		{
			text: "Name",
			value: "name"
		},
		{
			text: "Dispatch",
			value: "dispatch"
		},
		{
			text: "Safety",
			value: "safety"
		},
		{
			text: "Billing",
			value: "billing"
		},
		{
			text: "Salary",
			value: "salary"
		},
		{
			text: "Base rate",
			value: "base_rate"
		},
		{
			text: "Bonus/Charge",
			value: "bonus"
		},
		{
			text: "Description",
			value: "description"
		},
		{
			text: "Total",
			value: "total"
		}
	],

	4: [
		{
			text: "Name",
			value: "name"
		},
		{
			text: "Dispatch",
			value: "dispatch"
		},
		{
			text: "Safety",
			value: "safety"
		},
		{
			text: "Billing",
			value: "billing"
		},
		{
			text: "Dispatch manager",
			value: "dispatcher_dispatch"
		},
		{
			text: "Safety manager",
			value: "dispatcher_safety"
		},
		{
			text: "Billing manager",
			value: "dispatcher_billing"
		},
		{
			text: "Salary",
			value: "salary"
		},
		{
			text: "Base rate",
			value: "base_rate"
		},
		{
			text: "Bonus/Charge",
			value: "bonus"
		},
		{
			text: "Description",
			value: "description"
		},
		{
			text: "Total",
			value: "total"
		},
	],
	5: [
		{
			text: "Driver",
			value: "driver"
		},
		{
			text: "Altex driver",
			value: "altex_driver"
		},
		{
			text: "Salary",
			value: "salary"
		},
		{
			text: "Bonus",
			value: "bonus"
		},
		{
			text: "Charge",
			value: "charge"
		},
		{
			text: "Rate",
			value: "rate",
		},
		{
			text: "Description",
			value: "description"
		},
		{
			text: "Total",
			value: "total"
		}
	],
	7: [
		{ width: '34px', isCheckbox: true, isCheckboxAll: true, isCheckboxTotal: true },

		{
			settings: true,
			text: "Dispatcher",
			value: "personal_name",
			valueFilter: "filter_personal_name",
			model: { value: 'list' },
			func: true,
			sortable: true,
			footer: "count"
		},
		{
			settings: true,
			text: "Bonus",
			value: "bonus",
			valueFilter: "filter_bonus",
			func: true,
			model: { value: 'number' },
			sortable: true,
			dollar: true,
			toLeft: true,
		},
		{
			settings: true,
			text: "Base rate",
			value: "base_rate",
			valueFilter: "filter_base_rate",
			func: true,
			model: { value: 'number' },
			sortable: true,
			dollar: true
		},
		{
			settings: true,
			text: "Gross",
			value: "gross",
			valueFilter: "filter_gross",
			func: true,
			model: { value: 'number' },
			sortable: true,
			dollar: true
		},
		{
			settings: true,
			text: "Salary",
			value: "salary",
			valueFilter: "filter_salary",
			func: true,
			model: { value: 'number' },
			sortable: true,
			dollar: true,
			toLeft: true,
		},
		{
			settings: true,
			text: "Rate",
			value: "dispatcher_rate",
			valueFilter: "filter_dispatcher_rate",
			func: true,
			model: { value: 'number' },
			sortable: true,
			toLeft: true,
		},
		{
			settings: true,
			text: "Total",
			value: "total",
			valueFilter: "filter_total",
			func: true,
			model: { value: 'number' },
			sortable: true,
			dollar: true,
			toLeft: true,
		},
		{
			settings: true,
			buttons: [
				{
					perm: true,
					value: 'openLoadsDispatcher',
					text: 'St-t',
					icon: { value: 'icon_view', w: 17, h: 14 },
				}
			]
		},
	],
};
